import "./App.css";
import PortfolioContainer from "./PortfolioContainer/PortfolioContainer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import MarqueeText from "./PortfolioContainer/Marqee/Marquee";

function App() {
  const [marquee, setMarquee] = useState(true);
  const onScrollHandler = () => {
    window.document.removeEventListener('scroll', onScrollHandler)
    setMarquee(false)
  }
  window.document.addEventListener('scroll', onScrollHandler)
  return (
    <div className="App">
      <ToastContainer />
      <PortfolioContainer />
      {marquee && <MarqueeText />}
    </div>
  );
}

export default App;
